module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/dashkit-layered-9cce5a241c2041c55647cacc9b6001fa.png";